import Clipboard from '@common/Clipboard/Clipboard'

import { Object } from '@common/Object/Object'
import { String } from '@common/String/String'

import ButtonGroup from '../ButtonGroup/ButtonGroup'
import Button      from '../Button/Button'
import Input       from '../Input/Input'
import Label       from '../Label/Label'

import styles from './PasswordGenerator.css'

export interface IPasswordGeneratorElement extends HTMLElement {
  readonly password: string
}

interface IProps {
  readonly length?: number
  readonly password?: string
}

const DEFAULT_LENGTH = 8

/**
 * Jelszógeneráló komponens factory-ja.
 * @param props - JSX props {@link IProps}.
 */
export default function PasswordGenerator (props: IProps): IPasswordGeneratorElement {
  const { length = DEFAULT_LENGTH, password = '' } = props

  const input: HTMLInputElement = <Input name="passwd" isDisabled value={ password } />
  input.value = password // HACK: ez maradjon így

  /** Vágólapra való kimásoláskor hívódó callback. */
  async function onClickCopy (): Promise<void> {
    input.disabled = false
    input.select()

    await Clipboard.setContent(input.value)

    // eslint-disable-next-line require-atomic-updates
    input.disabled = true
    input.blur()
  }

  const copyBtn: HTMLButtonElement = (
    <Button
      isDisabled
      type="primary"
      onClick={ onClickCopy }
    >
      Vágólapra másolás
    </Button>
  )

  /** Új jelszó igénylésekor hívódó callback. */
  function onClickNewPassword (): void {
    input.value = String.getRandomLetters(length)

    copyBtn.removeAttribute('disabled')
  }

  const el: IPasswordGeneratorElement = (
    <div className={ styles.passwordGenerator }>
      <Label>Jelszó</Label>

      <div data-container>
        { input }

        <ButtonGroup>
          <Button type="primary" onClick={ onClickNewPassword }>Új jelszó</Button>
          { copyBtn }
        </ButtonGroup>
      </div>

      <small>Új jelszót biztonsági okokból csak generáltatni lehet.</small>
    </div>
  )

  Object.defineProperty(el, 'password', {
    get: (): string => {
      return input.value
    }
  })

  return el
}
